export default "__VITE_ASSET__C4dUL0h9__"